import { useContext } from 'react';
import AuthContext, { AuthContextType } from './auth-provider';

const useAuth = () => {
  return useContext(AuthContext) as AuthContextType;
};

export default useAuth;
